export default  {
    "You can select up to {count} options": "Pode selecionar até {count} opções",
    "Please answer all required questions to continue": "Por favor, responda a todas as perguntas obrigatórias para continuar",
    "Next Section": "Próxima secção",
    "Previous Section": "Secção anterior",
    "Next Question": "Próxima pergunta",
    "Previous Question": "Pergunta anterior",
    "Complete": "Concluir",
    "Please enter all field properly": "Por favor, preencha todos os campos corretamente",
    "This question is required": "Esta pergunta é obrigatória",
    "Choose": "Escolher",
    "Other option": "Outra opção",
    "Read more": "Ler mais",
    "Show less": "Mostrar menos",
    "Loading": "A carregar",
    "Dashboard": "Dashboard",
    "Buy more answers": "Buy more answers",
    "Per-location QR codes": "Códigos QR por local",
    "Rooms / Tables / Locations": "Quartos / Mesas / Locais",
    "Generate one QR code per location (e.g. hotel rooms 101–150 or restaurant tables). Each QR carries its location, so answers are tagged automatically — the guest never types it. Choose a survey and answer type above first.": "Gere um código QR por local (por ex. quartos 101–150 ou mesas de restaurante). Cada QR carrega o seu local, por isso as respostas são identificadas automaticamente — o hóspede nunca o digita. Escolha primeiro um inquérito e um tipo de resposta acima.",
    "Add range": "Adicionar intervalo",
    "Extra locations (comma-separated, e.g. T1, T2, VIP)": "Locais adicionais (separados por vírgula, por ex. T1, T2, VIP)",
    "QR per page": "QR por página",
    "Label prefix (Room / Table / Σημείο)": "Prefixo do rótulo (Quarto / Mesa / Local)",
    "Caption (e.g. SCAN TO ANSWER)": "Legenda (por ex. SCAN TO ANSWER)",
    "Sheet title (defaults to survey name)": "Título da folha (predefinição: nome do inquérito)",
    "Generate QR PDF": "Gerar PDF QR",
    "locations": "locais",
    "Please choose a survey": "Escolha um inquérito",
    "No locations defined": "Nenhum local definido",
    "Too many locations (max 1000)": "Demasiados locais (máx. 1000)",
    "Invalid range (from must be <= to)": "Intervalo inválido (de deve ser ≤ até)",
    "PDF generated": "PDF gerado",
    "QR Code Sheet": "Folha de códigos QR",
    "Generated": "Gerado",
    "Location": "Local",
    "Location (room / table):": "Local (quarto / mesa):",
    "Exact / list (e.g. 205, 210)": "Exato / lista (por ex. 205, 210)",
    "Range from": "Intervalo de",
    "Range to": "Intervalo até",
    "Guest": "Hóspede",
    "Location — exact / list (e.g. 205, 210)": "Local — exato / lista (por ex. 205, 210)",
    "Location range from": "Intervalo de local de",
    "Location range to": "Intervalo de local até",
    "is": "é",
    "is not": "não é",
    "includes": "inclui",
    "does not include": "não inclui",
    "between": "entre",
    "contains": "contém",
    "does not contain": "não contém",
    "on": "em",
    "before": "antes",
    "after": "depois",
    "value": "valor",
    "min": "mín",
    "max": "máx",
    "If answer": "Se a resposta",
    "go to": "ir para",
    "Next question (default)": "Próxima pergunta (padrão)",
    "Add rule": "Adicionar regra",
    "Otherwise, go to": "Caso contrário, ir para",
    "Send the respondent to a different question depending on their answer to this question. Rules are checked top to bottom; the first match wins. If nothing matches, the default applies.": "Encaminhe o inquirido para uma pergunta diferente consoante a resposta a esta pergunta. As regras são verificadas de cima para baixo; a primeira correspondência vence. Se nenhuma corresponder, aplica-se a predefinição.",
    "Add this question's answer options first to build branching rules.": "Adicione primeiro as opções de resposta desta pergunta para criar regras.",
    "Logic / Branching": "Lógica / Ramificação",
    "optional": "opcional",
    "End of survey": "Fim do inquérito",
    "A question with branching rules is answered before the survey continues.": "Uma pergunta com regras de ramificação é respondida antes de o inquérito continuar.",

    // reports — modern Analytical/Summary labels
    "Overall score": "Pontuação geral",
    "Responses": "Respostas",
    "Positive": "Positivo",
    "positive": "positivo",
    "No answers": "Sem respostas",

    // reports — Summary period comparison
    "Period 1": "Período 1",
    "Period 2": "Período 2",
    "Compare periods": "Comparar períodos",
    "set Period 2": "definir período 2",

    // reports — Text reports search/sort
    "No respondents match": "Nenhum respondente corresponde a",
    "Search by location, name, email or answer text…": "Pesquisar por local, nome, email ou texto da resposta…",
    "Sorted worst score first — the responses that need attention are at the top.": "Ordenado da pior pontuação primeiro — as respostas que precisam de atenção estão no topo.",

    // reports — Excel export
    "Excel export is not available for this report": "A exportação para Excel não está disponível para este relatório",
    "Choose a report type above to begin": "Escolhe um tipo de relatório acima para começar",
    "Filters": "Filtros",
    "Hide filters": "Ocultar filtros",
    "Show results": "Mostrar resultados",
    "Print": "Imprimir",
    "Answer:": "Resposta:",
    "Choose a report type": "Escolhe um tipo de relatório",
};